import { render, staticRenderFns } from "./PrivacyinfoDetail_20130901.vue?vue&type=template&id=666c8cc1&scoped=true&"
import script from "./PrivacyinfoDetail_20130901.vue?vue&type=script&lang=js&"
export * from "./PrivacyinfoDetail_20130901.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyinfoDetail_20130901.vue?vue&type=style&index=0&id=666c8cc1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666c8cc1",
  null
  
)

export default component.exports